import { render, staticRenderFns } from "./AdSpaceScreenSaverItem.vue?vue&type=template&id=3dce046b&scoped=true&"
import script from "./AdSpaceScreenSaverItem.vue?vue&type=script&lang=ts&"
export * from "./AdSpaceScreenSaverItem.vue?vue&type=script&lang=ts&"
import style0 from "./AdSpaceScreenSaverItem.vue?vue&type=style&index=0&id=3dce046b&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dce046b",
  null
  
)

export default component.exports